import {
  SoloProposalSchema,
  LightreachProposalSchema,
  FundingProposalSchema,
} from "rdx/modules/projects/schemas/projects/post-sales/proposals";
import { ProposalKindEnum } from "rdx/modules/projects/enums";
import type { SoloProposalT, VisionProposalT, FundingProposalT } from "./proposals";

export function isSoloProposal(data: unknown): data is SoloProposalT {
  return SoloProposalSchema.safeParse(data).success;
}

export function isLightreachProposal(data: unknown): data is SoloProposalT {
  return LightreachProposalSchema.safeParse(data).success;
}

export function isVisionProposal(data: unknown): data is VisionProposalT {
  const { kind } = (data as { kind?: string }) || {};
  return kind === ProposalKindEnum.VISION || kind === ProposalKindEnum.VISION_LITE;
}

export function isFundingProposal(data: unknown): data is FundingProposalT {
  return FundingProposalSchema.safeParse(data).success;
}
